export default __webpack_public_path__ + "static/media/xalgo.8b283d59.png";